module.exports = __webpack_public_path__ + "static/media/Tag-3.f33f1a8a.png";